import $ from 'jquery';

export default (comparison = false) => ({
  name: 'compCalcHM',
  // * data()
  showUSACS: true,
  hasComparison: comparison,
  desktop: window.innerWidth >= 1280 ? true : false,
  showComp: false,
  showButton: false,
  toggle() {
    this.showUSACS = !this.showUSACS;
    this.showComp = !this.showComp;
  },
  checkComparison() {
    if (this.desktop && this.hasComparison) {
      this.showComp = true;
      this.showButton = false;
    }
    if (!this.desktop && this.hasComparison) {
      this.showComp = false;
      this.showButton = true;
    }
  },
  init() {
    this.checkComparison();

    var calcSheet = {
      b: {},
      c: {},
      e: {},
      f: {},
    };

    var inputColumns = {
      b: [],
      e: [24],
    };

    var matchColumns = {
      c: { b: [8, 10, 11, 12, 16, 17, 19, 21, 22] },
      f: { e: [8, 10, 11, 12, 16, 17, 19, 21, 22] },
    };

    var totalColumns = {
      c: {
        row: 28,
        start: 8,
        end: 23,
      },
      f: {
        row: 28,
        start: 8,
        end: 27,
      },
    };

    var outputColumns = ['c', 'e', 'f'];

    function set401k() {
      var c14 =
        (calcSheet['b']['14'] / 100) * (calcSheet['c']['8'] + calcSheet['c']['10'] + calcSheet['c']['11'] + calcSheet['c']['12'] + calcSheet['c']['21'] + calcSheet['c']['22']);
      if (c14 < 33000) {
        setCalcVal('c', '14', c14);
      } else {
        setCalcVal('c', '14', 33000);
      }

      var f14 =
        (calcSheet['e']['14'] / 100) * (calcSheet['f']['8'] + calcSheet['f']['10'] + calcSheet['f']['11'] + calcSheet['f']['12'] + calcSheet['f']['21'] + calcSheet['f']['22']);
      if (f14 < 33000) {
        setCalcVal('f', '14', f14);
      } else {
        setCalcVal('f', '14', 33000);
      }
    }

    function setCompensationPerShift() {
      setCalcVal('c', '29', calcSheet['b']['7'] > 0 ? calcSheet['c']['28'] / (calcSheet['b']['7'] * (365 / 28)) : 0);
      setCalcVal('f', '29', calcSheet['e']['7'] > 0 ? calcSheet['f']['28'] / (calcSheet['e']['7'] * (365 / 28)) : 0);
    }

    function setMiscPay() {
      var e24 = calcSheet['f']['8'] * 0.062;
      console.log(e24);
      e24 = e24 < 7960 ? e24 : 7960;
      e24 += 0.0145 * (calcSheet['f']['8'] + calcSheet['f']['10'] + calcSheet['f']['11'] + calcSheet['f']['12'] + calcSheet['f']['21'] + calcSheet['f']['22'] + calcSheet['f']['23']);
      
      e24 = e24 <= 19864 ? e24 : 19864;

      setCalcVal('e', '24', e24);
      setCalcVal('f', '24', e24 * -1);
      setCalcVal('f', '25', calcSheet['e']['25'] * -1);
      setCalcVal('f', '26', calcSheet['e']['26'] * -1);
      setCalcVal('f', '27', calcSheet['e']['27'] * -1);
    }

    function setIntangiblesValues() {
      document.getElementById('pLeave').innerHTML = fCur(
        ((-1 * (calcSheet['f']['8'] + calcSheet['f']['10'] + calcSheet['f']['11'] + calcSheet['f']['12'] + calcSheet['f']['14'] + calcSheet['f']['21'] + calcSheet['f']['22'])) /
          365) *
          56
      );
      document.getElementById('mLeave').innerHTML = fCur(
        ((-1 * (calcSheet['f']['8'] + calcSheet['f']['10'] + calcSheet['f']['11'] + calcSheet['f']['12'] + calcSheet['f']['14'] + calcSheet['f']['21'] + calcSheet['f']['22'])) /
          365) *
          90
      );
    }

    function setCustomValues() {
      //set all output values that don't match inputs
      set401k();
      setMiscPay();
      setTotal();
      setCompensationPerShift();
      setIntangiblesValues();
    }

    function storageAvailable(type) {
      try {
        var storage = window[type],
          x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
      } catch (e) {
        return (
          e instanceof DOMException &&
          // everything except Firefox
          (e.code === 22 ||
            // Firefox
            e.code === 1014 ||
            // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' ||
            // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
          // acknowledge QuotaExceededError only if there's something already stored
          storage.length !== 0
        );
      }
    }

    if (storageAvailable('localStorage')) {
      var urlParams = new URLSearchParams(window.location.search);
      var calcPrefix = urlParams.get('calc');
      var calcInputs = $('.calc-container').find('input:enabled');
      calcInputs.each(function (index, el) {
        var id = calcPrefix + '_' + $(el).attr('id');
        if (localStorage.getItem(id) !== null) {
          $(el).val(localStorage.getItem(id));
        }

        $(el).on('change', function () {
          localStorage.setItem(id, $(el).val());
        });
      });

      $('<button />')
        .attr({
          class: 'button',
        })
        .text('Reset')
        .on('click', function (e) {
          e.preventDefault();
          calcInputs.each(function (index, el) {
            $(el).val(0);
            localStorage.removeItem(calcPrefix + '_' + $(el).attr('id'));
          });
          updateCalc();
        })
        .prependTo($('.calc-container').find('table tr:first > td:first'));
    }

    $('.js-calc-input').keyup(function (e) {
      updateCalc();
    });

    $('.js-calc-input').change(function (e) {
      updateCalc();
    });

    updateCalc();

    $('.js-activate-usacs').click(function (e) {
      e.preventDefault();
      $(this).removeClass('button--secondary');
      $('.js-activate-comp').addClass('button--secondary');

      $('.calc--usacs').show();
      $('.calc--comp').hide();
    });

    $('.js-activate-comp').click(function (e) {
      e.preventDefault();
      $(this).removeClass('button--secondary');
      $('.js-activate-usacs').addClass('button--secondary');

      $('.calc--usacs').hide();
      $('.calc--comp').show();
    });
    function fCur(value) {
      // Convert the value to a floating point number in case it arrives as a string.
      var numeric;
      if (value < 0) {
        value = value * -1;
        numeric = '-$' + value.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      } else {
        numeric = '$' + value.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      }

      // Specify the local currency.
      return numeric;
    }

    function cleaner(value) {
      var cleaned = value.toString().replace(',', '');
      cleaned = parseFloat(cleaned.replace('$', ''));

      if (!isFinite(cleaned) || isNaN(cleaned)) {
        return 0;
      } else {
        return cleaned;
      }
    }

    function setCalcVal(col, row, val) {
      calcSheet[col][row] = cleaner(val);
    }

    function getInputValues() {
      //get all input values
      $.each(inputColumns, function (col, rows) {
        $('input[id^="' + col + '"]').each(function (index, el) {
          var row = parseInt($(el).attr('id').replace(col, ''));
          if (rows.indexOf(row) === -1) {
            setCalcVal(col, row, $(el).val());
          }
        });
      });
    }

    function setMatchingOutputValues() {
      //set all output values that match inputs
      $.each(matchColumns, function (matchColKey, valCol) {
        $.each(valCol, function (valColKey, rowCols) {
          $.each(rowCols, function (index, matchCalRow) {
            setCalcVal(matchColKey, matchCalRow, calcSheet[valColKey][matchCalRow]);
          });
        });
      });
    }

    function outputValue(elem, val) {
      var input = $('#' + elem);
      if (input.attr('type') !== 'number') {
        $('#' + elem).val(fCur(val));
      } else {
        $('#' + elem).val(val);
      }
    }

    function outputValues() {
      $.each(outputColumns, function (index, col) {
        if (inputColumns.hasOwnProperty(col)) {
          $.each(inputColumns[col], function (index, row) {
            outputValue(col + row, calcSheet[col][row]);
          });
        } else {
          $.each(calcSheet[col], function (row, val) {
            outputValue(col + row, val);
          });
        }
      });
    }

    function setTotal() {
      $.each(totalColumns, function (col, rowData) {
        var total = 0;
        $.each(calcSheet[col], function (row, val) {
          if (row >= rowData.start && row <= rowData.end) {
            total += val;
          }
        });
        setCalcVal(col, rowData.row, total);
      });
    }

    function setHourlyValues() {
      if (typeof hourlyColumns !== 'undefined') {
        //set all output values that match inputs
        var hours = calcSheet[hourlyColumns['hours'][0]][hourlyColumns['hours'][1]];
        $.each(hourlyColumns, function (matchColKey, valCol) {
          if (matchColKey !== 'hours') {
            $.each(valCol, function (valColKey, rowCols) {
              $.each(rowCols, function (index, matchCalRow) {
                setCalcVal(matchColKey, matchCalRow, calcSheet[valColKey][matchCalRow] / hours);
              });
            });
          }
        });
      }
    }

    function updateCalc() {
      getInputValues();
      setMatchingOutputValues();
      setCustomValues();
      setHourlyValues();
      outputValues();
    }
  },
});
